'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('./styles/colors');

var _typography = require('./styles/typography');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headlineStyle = _extends({}, _typography.text, _typography.semibold, {
    fontSize: 16,
    lineHeight: '24px',
    marginBottom: 8,
    color: _colors.graphite,
    whiteSpace: 'pre-wrap'
});

var copyStyle = _extends({}, _typography.text, {
    lineHeight: '24px'
});

var ModalCopy = function ModalCopy(_ref) {
    var _ref$headline = _ref.headline,
        headline = _ref$headline === undefined ? '' : _ref$headline,
        _ref$copy = _ref.copy,
        copy = _ref$copy === undefined ? '' : _ref$copy;
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { style: headlineStyle },
            headline
        ),
        _react2.default.createElement(
            'div',
            { style: copyStyle },
            copy
        )
    );
};

exports.default = ModalCopy;
//# sourceMappingURL=ModalCopy.js.map